import { text_mod_133 } from "../text/Text.js";
export const module133 = {

  title: "Урок 133. Множення чисел на 10 і 100. Порівняння виразів. Ділення круглих чисел на 10 і 100. Дециметр. Робота з геометричним матеріалом. Множення і ділення круглих чисел на 100 і 10.",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_133,
    },
  ],
};
